/**
 * The one entry into "create my tournament" (나의 대회, CLAUDE.md §15 #405): landing, menus, the
 * sign-up redirect and the app all link here; the page makes the personal space and opens the
 * wizard. Kept dependency-free so the landing page can import it.
 */
export const CREATE_PERSONAL_PATH = '/me/tournaments/new';
